/* eslint-disable */
require('./alert')
require('./align')
require('./arrow-circle')
require('./arrow')
require('./award')
require('./bell')
require('./bold')
require('./button-1')
require('./button')
require('./calendar')
require('./camera')
require('./chart')
require('./check')
require('./chevron')
require('./clock')
require('./code')
require('./comment')
require('./crown')
require('./download')
require('./edit')
require('./external-link')
require('./eye')
require('./file')
require('./filter')
require('./g_calendar')
require('./h')
require('./h1')
require('./h2')
require('./h3')
require('./h4')
require('./h5')
require('./help')
require('./home')
require('./image')
require('./info')
require('./italic')
require('./link')
require('./list')
require('./mail')
require('./minus')
require('./more')
require('./number')
require('./oc')
require('./office')
require('./ol')
require('./p')
require('./paperclip')
require('./plus')
require('./printer')
require('./scout')
require('./search')
require('./send')
require('./settings')
require('./slack')
require('./spacer')
require('./star-blue')
require('./star-blue-empty')
require('./star-empty-white')
require('./star-gray')
require('./tag')
require('./timer')
require('./trash')
require('./underline')
require('./user')
require('./users')
require('./video')
require('./x')
require('./zoom')
